<template>
  <div>
    <div class="logo">
      <i
        class="iconfont iconicon-sort2 fz18 marl20 vsbot"
        v-if="!bg"
        @click="collapseChage"
      ></i>
      <a href="javascript:;">
        <img
          :src="logoSrc.default"
          class="logoImg"
          alt="logo"
          @click="workbench"
        />
        <span @click="workbench">医学影像质量控制平台</span>
        <span class="versionNo">{{ versionNo }}</span>
      </a>
    </div>
    <div class="homeUserNavR">
      <p v-if="selectRole.length == 1">
        <span class="fz14">{{ userName.stationName }}</span>
      </p>
      <el-dropdown v-else @command="workListBtn">
        <span class="el-dropdown-link">
          {{ userName.stationName }}
          <i class="el-icon-caret-bottom el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in selectRole"
            :key="index"
            :command="item"
          >
            {{ item.StationName }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <p class="homeUserNavRName">
        <span>{{ userName.name }}</span>
        <i>｜</i>
        <span>{{ userName.roleName }}</span>
      </p>
      <el-dropdown size="medium" @command="handleCommand">
        <span class="el-dropdown-link">
          <i
            class="iconfont iconicon-topNavigation-setting fz18 changePassword"
          ></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="1">修改密码</el-dropdown-item> -->
          <el-dropdown-item command="3">
            <div>
              切换皮肤
              <el-switch
                @change="switchStatus"
                v-model="skinPeeler.status"
              ></el-switch>
            </div>
          </el-dropdown-item>
          <el-dropdown-item command="2">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <i class="iconfont iconicon-topNavigation-close1 fz18 exit" @click="exit"></i> -->
      <!-- <template>
				<el-dialog title="修改密码" :modal-append-to-body="false" :visible.sync="dialogVisible.open" width="30%">
					<el-form ref="formInlines" :model="formInlines" :rules="rules" label-width="80px">
						<el-form-item label="原密码" prop="OldPassword">
							<el-input v-model="formInlines.OldPassword" placeholder="请输入原始密码"></el-input>
						</el-form-item>
						<el-form-item label="新密码" prop="NewPassword">
							<el-input v-model="formInlines.NewPassword" placeholder="请输入新密码"></el-input>
						</el-form-item>
						<el-form-item label="确认密码" prop="checkPass">
							<el-input v-model="formInlines.checkPass" placeholder="请输入新密码"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="dialogVisible.open = false">取 消</el-button>
						<el-button size="mini" type="primary" @click="cancle">确 定</el-button>
					</span>
				</el-dialog>
			</template> -->
    </div>
  </div>
</template>

<script>
import { cookieHandle } from "@/js/common";
import axios from "@/js/api";
import { myMixin } from "@/assets/mixin.js";
// import { mapState, mapActions, mapMutations} from 'vuex'
export default {
  inject: ["reload"],
  name: "home",
  props: ["bg"],
  mixins: [myMixin],
  data() {
    // let validatePass = (rule, value, callback) => {
    // 	if (value === '') {
    // 		callback(new Error('请输入新密码'));
    // 	} else {
    // 		if (value.length < 6) {
    // 			callback(new Error('最少输入6位'));
    // 		}
    // 		if (this.formInlines.checkPass !== '') {
    // 			this.$refs.formInlines.validateField('checkPass');
    // 		}
    // 		callback();
    // 	}
    // };
    // let validatePass2 = (rule, value, callback) => {
    // 	if (value === '') {
    // 		callback(new Error('请再次输入密码'));
    // 	} else if (value !== this.formInlines.NewPassword) {
    // 		callback(new Error('两次输入密码不一致!'));
    // 	} else {
    // 		callback();
    // 	}
    // };
    return {
      // rules: {
      // 	NewPassword: [{
      // 		required: true,
      // 		validator: validatePass,
      // 		trigger: 'blur'
      // 	}, ],
      // 	checkPass: [{
      // 		required: true,
      // 		validator: validatePass2,
      // 		trigger: 'blur'
      // 	}, ],
      // 	OldPassword: [{
      // 		required: true,
      // 		message: '请输入旧密码',
      // 		trigger: 'blur'
      // 	}, ]
      // },
      userName: JSON.parse(localStorage.getItem("user")),
      userNameType: JSON.parse(
        JSON.parse(localStorage.getItem("user")).permissions
      )[0].KeyName,
      selectRole: JSON.parse(localStorage.getItem("selectRole")),
    };
  },
  computed: {
    ...Vuex.mapState("breadcrumb", [
      "versionNo",
      "menuStatus",
      "skinPeeler",
      "isTree",
    ]),
    ...Vuex.mapState("supervisor", ["formInlines", "dialogVisible"]),
    ...Vuex.mapState("login", ["dynamicValidateForm"]),
  },
  activated() {
    this.switchStatus();
  },
  methods: {
    ...Vuex.mapMutations("supervisor", ["clearPass"]),
    ...Vuex.mapMutations("breadcrumb", ["changeisTree"]),
    ...Vuex.mapActions("supervisor", ["ChangePasswordAct"]),
    ...Vuex.mapActions("login", ["GetEnableRoles", "ChangeRole"]),
    // 官网首页
    officialhome() {
      window.location.href = "https://www.rimagdata.com/";
    },
    workbench() {
      this.$router.push("/workbench");
    },
    // handleCommand(command) {
    // 	//显示修改密码弹窗
    // 	if (command == 'changePassword') {
    // 		this.clearPass();
    // 		this.dialogVisible.open = true;
    // 	}
    // },
    workListBtn(item) {
      this.changeisTree(true);
      this.dynamicValidateForm.RoleId = item.RoleGuid;
      this.userName.roleName = item.RoleName;
      this.userName.stationName = item.StationName;
      this.ChangeRole().then((res) => {
        this.reload();
      });
    },
    handleCommand(command) {
      const basicUrl = process.env.VUE_APP_DOMAIN_HREF;
      const homeUrl = process.env.VUE_APP_HOME_URL;
      const encodeUrl = encodeURIComponent(homeUrl);
      let url = "";
      if (command == 1) {
        url = `${basicUrl}/editpassword?callback_url=${encodeUrl}`;
        location.href = url;
      } else if (command == 2) {
        this.exit();
        // url = `${process.env.VUE_APP_LOGIN_URL}?callback_url=${encodeUrl}`;
      }
    },
    collapseChage() {
      this.menuStatus.isCollapse = !this.menuStatus.isCollapse;
      this.menuStatus.collapse = !this.menuStatus.collapse;
    },
    //退出
    exit() {
      let _this = this;
      // let loginUserCookieStr = cookieHandle.getCookie(process.env.VUE_APP_BASE_USERINFO),
      //   data = {},
      //   logincodeval = "",
      //   _this = this;
      // const logincode = JSON.parse(decodeURIComponent(loginUserCookieStr)).logincode,
      //   phone = JSON.parse(decodeURIComponent(loginUserCookieStr)).phone;

      // if (logincode && (logincode != null || logincode != "" || logincode != undefined)) {
      //   logincodeval = logincode;
      // } else {
      //   logincodeval = phone;
      // }
      this.$confirm("确定要退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          // _this.$router.push("/");
          axios.ssoOut("get", axios.Api.api.sso.loginOut).then((res) => {
            if (res.data.code == 200) {
              _this.changeisTree(true);
              let homeUrl = process.env.VUE_APP_HOME_URL;
              const encodeUrl = encodeURIComponent(homeUrl);
              const url = `${process.env.VUE_APP_LOGIN_URL}?callback_url=${encodeUrl}`;
              localStorage.clear();
              cookieHandle.clearCookie();
              location.href = url;
            }
          });
        })
        .catch((err) => {
          console.log(err, "err");
          this.$message({
            type: "info",
            message: "已取消退出登录",
          });
        });
    },
    //修改密码
    cancle() {
      this.$refs.formInlines.validate((valid) => {
        if (valid) {
          this.ChangePasswordAct();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped="scoped">
.home .homeUserNav .homeUserNavRName .el-icon-caret-bottom {
  padding: 0 !important;
}
</style>
